<template>
  <nav
    v-show="isShow"
    class="pagination"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination-list">
      <li>
        <button
          class="pagination-link button"
          @click.prevent="onChange(1)"
          :disabled="!isEnablePrevious"
        >
          <i class="fa fa-angle-double-left"></i>
        </button>
      </li>
      <li>
        <button
          class="pagination-link button"
          @click.prevent="onChange(page-1)"
          :disabled="!isEnablePrevious"
        >
          <i class="fa fa-angle-left"></i>
        </button>
      </li>
      <li>
        <button
          v-show="Firtellipsis"
          class="button"
          :class="{'pagination-link': true, 'is-current ': currentstart }"
          @click.prevent="onChange(firt)"
        >{{firt}}</button>
      </li>
      <li v-show="PagiEllipsis">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>

      <li v-show="one">
        <button
          class="button"
          :class="{'pagination-link': true, 'is-current': actives[0]}"
          @click.prevent="onChange(numbers[0])"
        >{{numbers[0]}}</button>
      </li>

      <li v-show="two">
        <button
          class="button"
          :class="{'pagination-link': true, 'is-current': actives[1]}"
          @click.prevent="onChange(numbers[1])"
        >{{numbers[1]}}</button>
      </li>
      <!-- cheat nhẹ -->
      <li
        v-show="three"
        :class="endPage == 2 ? 'disablepage' :''"
      >
        <button
          class="button"
          :class="{'pagination-link': true, 'is-current': actives[2]}"
          @click.prevent="onChange(numbers[2])"
        >{{numbers[2]}}</button>
      </li>
      <li v-show="ellipsis">
        <span class="pagination-ellipsis">&hellip;</span>
      </li>
      <li>
        <button
          class="button"
          v-show="endellipsis"
          :class="{'pagination-link': true, 'is-current': currentend}"
          @click.prevent="onChange(endPage)"
        >{{endPage}}</button>
      </li>
      <!-- <li v-show="isShowLastEl">
        <a :class="{'pagination-link': true, 'is-current': actives[3]}" @click.prevent="onChange(endPage)">{{endPage}}</a>
      </li>-->
      <li>
        <button
          class="button pagination-link"
          @click.prevent="onChange(page+1)"
          :disabled="!isEnableNext"
        >
          <i class="fa fa-angle-right"></i>
        </button>
      </li>
      <li>
        <button
          class="button pagination-link"
          @click.prevent="onChange(endPage)"
          :disabled="!isEnableNext"
        >
          <i class="fa fa-angle-double-right"></i>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: "pagination",
    props: {
      total: Number,
      startPage: Number,
      size: Number
    },
    data () {
      return {
        isShow: false,
        isShowLastEl: true,
        isEnablePrevious: true,
        isEnableNext: true,
        numbers: [],
        actives: [true, false, false],
        endPage: 0,
        page: 0,
        ellipsis: false,
        Firtellipsis: false,
        firt: 1,
        endellipsis: false,
        PagiEllipsis: false,
        tempnu: [],
        one: true,
        two: true,
        three: true,
        tempnu2: [],
        currentstart: false,
        currentend: false
      };
    },
    methods: {
      // ssdfsdf
      init () {
        this.isShow = false;
        this.isShowLastEl = true;
        this.isEnablePrevious = true;
        this.isEnableNext = true;
        // this.numbers = [1, 2, 3, this.endPage];
        this.actives = [true, false, false];
        this.endPage = Math.ceil(this.total / this.size);
        this.page = this.page === 0 ? this.startPage : this.page;
        if (this.page < 1) {
          this.page = 1;
        }
        this.numbers = [1, 2, 3];
        this.endPage > 4 ? (this.ellipsis = true) : (this.ellipsis = false);
        this.page == 1 ? (this.currentstart = true) : (this.currentstart = false);
        this.page == this.endPage
          ? (this.currentend = true)
          : (this.currentend = false);
        if (this.endPage > 4) {
          this.page >= this.endPage - 2
            ? (this.ellipsis = false)
            : (this.ellipsis = true);
          this.page >= this.endPage - 1
            ? (this.endellipsis = false)
            : (this.endellipsis = true);
          this.page >= 3
            ? (this.Firtellipsis = true)
            : (this.Firtellipsis = false);
          this.page >= 4
            ? (this.PagiEllipsis = true)
            : (this.PagiEllipsis = false);

          //this.page == this.endPage - 3  || this.page == this.endPage ? this.ellipsis =false : this.ellipsis = true;
        } else if (this.endPage == 4) {
          this.page >= this.endPage - 1
            ? (this.endellipsis = false)
            : (this.endellipsis = true);
          this.page >= 3
            ? (this.Firtellipsis = true)
            : (this.Firtellipsis = false);
        }
        if (this.endPage > 1) {
          if (this.page < 1) {
            this.page = 1;
            this.numbers = this.numbers.map((el, i) => i + this.page + 1);
          } else if (this.page >= this.endPage) {
            this.page = this.endPage;
            if (this.page > 4) {
              this.numbers = this.numbers.map((el, i) => i + this.page - 2);
            }
          } else {
            if (this.endPage == 2) {
              this.numbers = [1, 2];
              this.one = true;
              this.two = true;
              this.three = false;
              this.ellipsis = false;
              this.endellipsis = false;
              this.Firtellipsis = false;
              this.PagiEllipsis = false;
              this.numbers = this.numbers.map((el, i) => i + this.page);
            } else if (this.endPage == 3) {
              this.numbers = [1, 2, 3];
              this.one = true;
              this.two = true;
              this.three = true;
              this.ellipsis = false;
              this.endellipsis = false;
              this.Firtellipsis = false;
              this.PagiEllipsis = false;
            } else {
              this.numbers = [1, 2, 3];
              this.one = true;
              this.two = true;
              this.three = true;
              this.endPage > 4
                ? (this.ellipsis = true) && (this.endellipsis = true)
                : (this.ellipsis = false) && (this.endellipsis = false);
              if (this.endPage > 4) {
                this.page >= this.endPage - 2
                  ? (this.ellipsis = false)
                  : (this.ellipsis = true);
                this.page >= this.endPage - 1
                  ? (this.endellipsis = false)
                  : (this.endellipsis = true);

                this.page >= 4
                  ? (this.Firtellipsis = true)
                  : (this.Firtellipsis = false);
                this.page >= 4
                  ? (this.PagiEllipsis = true)
                  : (this.PagiEllipsis = false);

                //this.page == this.endPage - 3  || this.page == this.endPage ? this.ellipsis =false : this.ellipsis = true;
              } else if (this.endPage == 4) {
                this.page >= this.endPage - 1
                  ? (this.endellipsis = false)
                  : (this.endellipsis = true);
                this.page >= 3
                  ? (this.Firtellipsis = true)
                  : (this.Firtellipsis = false);
              } else if (this.page == this.endPage) {
                this.endPage = false;
                this.endellipsis = false;
              }
              this.numbers = this.numbers.map((el, i) => i + this.page);
            }
          }

          this.position();
          this.active();
          this.isShow = true;
        }
      },
      onChange (page) {
        this.page = page;
        this.init();
        this.$emit("onChangePage", page);
      },
      position () {
        if (this.numbers.indexOf(this.page) !== 1) {
          if (this.numbers.indexOf(this.page) === 0) {
            if (this.numbers[0] > 1) {
              this.numbers = this.numbers.map(el => el - 1);
            }
          } else {
            if (this.numbers[2] < this.endPage)
              this.numbers = this.numbers.map(el => el + 1);
          }
        }
      },
      active () {
        this.actives = this.actives.map(
          (el, i) => i === this.numbers.indexOf(this.page)
        );
        if (this.page === 1) {
          this.isEnablePrevious = false;
          this.isEnableNext = true;
        } else if (this.page === this.endPage) {
          this.isEnableNext = false;
          this.isEnablePrevious = true;
        } else {
          this.isEnablePrevious = true;
          this.isEnableNext = true;
        }
      }
    },
    mounted () {
      this.init();
    },
    watch: {
      total () {
        this.init();
      },
      startPage () {
        this.page = this.startPage;
        this.active();
      },
      $route () {
        this.init();
      }
    }
  };
</script>

<style scoped>
  .disablepage {
    display: none;
  }
  .pagination-link:focus {
    border-color: #dbdbdb !important;
  }
  .button:focus,
  .button.is-focused {
    border-color: #dbdbdb !important;
    box-shadow: none;
  }
  .pagination-link:hover {
    border-color: #0095db !important;
  }
</style>
